import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Button } from 'react-native-paper';

import { LocalizationNameSpace } from '@/localization/types/localizationTypes';
import { EmptyCard } from '@/shared/components/EmptyCard';

type Props = {
  hasActiveFilters: boolean;
  onResetFilters: () => void;
  onCreatePress: () => void;
};

export const OrganizationAreaEmptyCard: FC<Props> = ({
  hasActiveFilters,
  onResetFilters,
  onCreatePress
}) => {
  const { t } = useTranslation(LocalizationNameSpace.PROFILE_SETTING, {
    keyPrefix: 'screens.organization-area'
  });

  return (
    <EmptyCard
      style={styles.emptyCard}
      description={hasActiveFilters ? t('emptyFiltered') : t('emptyArea')}
      footer={
        <Button
          mode="contained"
          onPress={hasActiveFilters ? onResetFilters : onCreatePress}
        >
          {hasActiveFilters ? t('resetFilters') : t('createOrganization')}
        </Button>
      }
    />
  );
};

const styles = StyleSheet.create({
  emptyCard: {
    marginHorizontal: 16
  }
});
